<template>
  <div>
    <b-row>
      <b-col>
        <b-form-select
          @change="$emit('input', selectedNurse.usrId)"
          v-model="selectedNurse"
          :disabled="disabled"
        >
          <template v-if="!isNurseSelected" slot="first">
            <option :value="null" disabled>-- Bitte Hebamme auswählen --</option>
          </template>
          <option
            v-for="nurse in availableNurses"
            :key="nurse.usrId"
            :value="nurse"
          >
            {{ nurse.usrFirstName }} {{ nurse.usrLastName }}
          </option>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          @click="assign(assignmentModes.PARTIALLY)"
          :disabled="!isNurseSelected || disabled"
          class="w-100 mb-3 mb-sm-0"
          >Teilweise zuweisen</b-button
        >
      </b-col>
      <b-col>
        <b-button
          @click="assign(assignmentModes.FULLY)"
          :disabled="!isNurseSelected || disabled"
          class="w-100"
          >Voll zuweisen</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { assignmentModeEnum } from "../utils/enums";

export default {
  name: "RequestActionsAdmin",
  props: {
    availableNurses: Array,
    disabled: Boolean
  },
  data() {
    return {
      selectedNurse: null,
      assignmentModes: assignmentModeEnum
    };
  },
  computed: {
    isNurseSelected() {
      return Boolean(this.selectedNurse);
    }
  },
  methods: {
    assign(mode) {
      this.$emit("assign", mode);
      this.selectedNurse = null;
    }
  }
};
</script>

<style scoped>
select {
  margin-bottom: 15px;
}
</style>
